<template>
  <div class="wrapper">
    <div class="animated fadeIn ">
      <div>
      <b-row>
        <b-col cols="12">
         <b-breadcrumb :items="breadcrumbs"/>
         <!-- Code added -->
          <b-card header-tag="header" footer-tag="footer" style=" margin-bottom: 0px;">
        <label style="">All Designs : </label> 
          <b-row class="boxto">     
                
                <b-col sm="6" lg="2" >
                <b-card no-body class="bg-aqua" >
                 <router-link  :to="'/style_list/' +'ALL_Designs'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-3 text-center countcolor" v-b-tooltip.hover title="All Design">{{ALL_Designs}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="My Designs"> All Designs</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>
            </b-row>
            <hr style="height:30px">

            <label>PO Design Styles : </label>         
            <b-row class="boxto">     
        <b-col sm="6" lg="2" >

                <b-card no-body class="bg-aqua">
                  <router-link  :to="'/style_list/' +'Inspection_Pending'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor"  v-b-tooltip.hover title="Inspection Pending">{{Inspection_Pending}} </h4>
                     <p class="text-center countcolor"  v-b-tooltip.hover title="Inspection Pending">Inspection Pending</p>
                  </b-card-body>
                   </router-link>   


                </b-card>
              </b-col>
                    <b-col sm="6" lg="2" >
                <b-card no-body class="bg-purpal"  >
                 <router-link  :to="'/style_list/' +'Inspection_Done'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Inspection Done">{{Inspection_Done}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Inpection Done"> Inspection Done</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>

              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-def"  >
                 <router-link  :to="'/style_list/' +'Inspection_Aprroved'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Inspection Done">{{Inspection_Aprroved}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Inpection Done"> Inspection Approved</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>

              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-green"  >
                 <router-link  :to="'/style_list/' +'Inspection_Rejected'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Inspection Done">{{Inspection_Rejected}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title="Inpection Done"> Inspection Rejected</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>


             <!--  <b-col sm="6" lg="2" >
                <b-card no-body class="bg-def" >
                <router-link  :to="{ name: 'Designspendingforapproval', params: { id: 'Designspendingforapproval' }, }">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs rejecte">{{designrejected}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title=" Designs rejected)"> Designs rejected</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col>

              <b-col sm="6" lg="2" >
                <b-card no-body class="bg-green" >
                <router-link  :to="'/style_list/' +'Designs_Feedback'">
                  <b-card-body class="pb-0">          
                    <h4 class="mb-0 display-4 text-center countcolor" v-b-tooltip.hover title="Designs rejecte">{{Designs_Feedback}}</h4>
                    <p style="padding-bottom: 20px;" class="text-center countcolor" v-b-tooltip.hover title=" Designs rejected)"> Designs Feedback</p>
                  </b-card-body> 
                  </router-link>          
                </b-card>
              </b-col> -->
             
            
            
            </b-row>

          </b-card>
        </b-col>
      </b-row>
    </div>



            
          <!-- </b-card>
        </b-col>
      </b-row>
    </div> -->




  </div>
</div>
 
           
          
</template>


<script>

import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from "@/utils/auth";
const axios = require('axios');
export default {
  name: 'dashboard',
  data: function () {
    return {
      name: 'dashboard',
      id: '',
      Firstmile:[],
      Lasttmile:[],
      Reverse:[],
     a:-1,
    pending_for_approval: 0,
    Designapproved:0,
    designrejected: 0,
    Designs_Feedback: 0,
      inprogress: 0,
      approved: 0,
      pending: 0,
      received: 0,




     Order_pending: 0,
     Order_received: 0,
     Order_submitted: 0,
    In_production: 0,
PO_Created: 0,
PO_submitted: 0,
TNA_approved: 0,
TNA_pending: 0,
TNA_submitted: 0,


pp_sample_approved: 0,
pp_sample_pending: 0,
pp_sample_requested: 0,
proto_sample_approved: 0,
proto_sample_pending: 0,
proto_sample_requested: 0,
Quotationsapproved:0,

rejected: 0,

ALL_Designs: 0,
Inspection_Pending:0,
Inspection_Done:0,
Inspection_Aprroved: 0,
Inspection_Rejected:0,



       breadcrumbs: [{
        text: 'Dashboard',
        active: true
      }]
    }
  },
 
  created: function () {
    
    this.displayDashboardData();
  },

  methods: {
    
      displayDashboardData: function () {
         var userData = localStorage.getItem('userData');
          var userInfo = JSON.parse(userData)
        this.access_token=userInfo[0]['token']
        axios.defaults.headers.common['x-access-token'] = this.access_token;
        axios.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8'
        axios.defaults.headers.common['Accept']= 'application/json';
        axios.defaults.headers.common['Origin']='http://localhost:8080';
         
        const Obj = {
           user_id:userInfo[0].user_id,
           user_type:userInfo[0].user_type,
           brand_id: userInfo[0].brand_assign,
              // user_id: 624,
              // brand_id: 344,     
                 
                  }
      axios.post(`${CONSTANTS.API_URL}/getdashboardcountforQC_Executive`,Obj)
                .then(response => {
                 var result = response.data
              console.log("Result",result);

                  if (result.returnmsg === 'Successful') {
                    this.resultData = response.data.returnvalue[0];
                this.ALL_Designs=result.returnvalue[0].All_Designs.ALL_Designs;
                // console.log("AllDesign", this.ALL_Designs);
                // this.Inspection_Pending=result.returnvalue[0].Design_Styles.Inspection_Pending;
                // this.Inspection_Done=result.returnvalue[0].Design_Styles.Inspection_Done;
                // this.Inspection_Aprroved=result.returnvalue[0].Design_Styles.Inspection_Aprroved;
                // this.Inspection_Rejected=result.returnvalue[0].Design_Styles.Inspection_Rejected;
                if(this.resultData.Design_Styles.Inspection_Pending=='' || this.resultData.Design_Styles.Inspection_Pending==null || this.resultData.Design_Styles.Inspection_Pending==undefined){
                                  this.Inspection_Pending= 0;
                    }
                    else{
                      this.Inspection_Pending= this.resultData.Design_Styles.Inspection_Pending
                    }

                    if(this.resultData.Design_Styles.Inspection_Done=='' || this.resultData.Design_Styles.Inspection_Done==null || this.resultData.Design_Styles.Inspection_Done==undefined){
                                  this.Inspection_Done= 0;
                    }
                    else{
                      this.Inspection_Done= this.resultData.Design_Styles.Inspection_Done
                    }

                    if(this.resultData.Design_Styles.Inspection_Aprroved=='' || this.resultData.Design_Styles.Inspection_Aprroved==null || this.resultData.Design_Styles.Inspection_Aprroved==undefined){
                      
                                  this.Inspection_Aprroved= 0;
                    }
                    else{
                      
                      this.Inspection_Aprroved= this.resultData.Design_Styles.Inspection_Aprroved
                    }

                    if(this.resultData.Design_Styles.Inspection_Rejected=='' || this.resultData.Design_Styles.Inspection_Rejected==null || this.resultData.Design_Styles.Inspection_Rejected==undefined){
                                  this.Inspection_Rejected= 0;
                    }
                    else{
                      this.Inspection_Rejected= this.resultData.Design_Styles.Inspection_Rejected
                    }

                // console.log("hiiii", this.Inspection_Done);
        // this.pending_for_approval = result.returnvalue.styles.pending_for_approval
        // this.Designapproved = result.returnvalue.styles.approved
        // this.designrejected = result.returnvalue.styles.rejected 
        // this.Designs_Feedback = this.resultData.Design_Styles.Designs_Feedback

        //  this.inprogress = result.returnvalue.quotations.inprogress
        //  this.approved = result.returnvalue.quotations.approved
        //  this.pending = result.returnvalue.quotations.pending
        //  this.received = result.returnvalue.quotations.received


        // this.Order_pending = result.returnvalue.orders.Order_pending
        // this.Order_received = result.returnvalue.orders.Order_received
        // this.Order_submitted = result.returnvalue.orders.Order_submitted
        
        // this.In_production = result.returnvalue.po.In_production
        // this.PO_Created = result.returnvalue.po.PO_Created 
        // this.PO_submitted = result.returnvalue.po.PO_submitted 
        // this.TNA_approved = result.returnvalue.po.TNA_approved 
        // this.TNA_pending = result.returnvalue.po.TNA_submitted
        
        
        // this.pp_sample_approved = result.returnvalue.sampling.pp_sample_approved 
        // this.pp_sample_pending = result.returnvalue.sampling.pp_sample_pending 
        
        // this.pp_sample_requested = result.returnvalue.sampling.pp_sample_requested 
        // this.proto_sample_approved = result.returnvalue.sampling.proto_sample_approved
        // this.proto_sample_pending = result.returnvalue.sampling.proto_sample_pending 
        // this.proto_sample_requested = result.returnvalue.sampling.proto_sample_requested
       
      
    
     
        }   
        
        })
        
         
            
            
          
       
        
    }
  }
};

</script>

<style>
.bg-aqua{
      background-color: #00c0ef !important;
      color: #fff!important;
}
.bg-green{
      background-color: #00a65a !important;
       color: #fff!important;
}
.bg-yellow{
      background-color: #f39c12 !important;
       color: #fff!important;
}
.bg-pink{
  background-color: #FF69B4 !important;
   color: #fff!important;
}
.bg-purpal{  
    background-color: #9370DB !important;
     color: #fff!important;
}
.bg-cyan{
      background-color: #008B8B !important;
       color: #fff!important;  
}
.bg-red{
      background-color: #dd4b39 !important;
       color: #fff!important;
}
.bg-def{
  background-color: #f09642 !important;
   color: #fff!important;
  
}
.boxto .card-body{
  padding: 0px!important;
}
.heading{
  padding: 12px 12px 5px 12px!important;
}
.countcolor
{
      color:white !important;

}
.pointer
{
  cursor: pointer!important;
}

</style>